import { figmaNodeIdUrlParam } from './utils/figmaLinkType';
export function readComparisonReferenceSource(value) {
    if (!value || typeof value !== 'object')
        return undefined;
    const v = value;
    const text = (s) => typeof s === 'string' && s.trim().length > 0 && s.length <= 500;
    const saved = v.savedDesign;
    if (saved !== undefined && (!saved || typeof saved !== 'object' || !text(saved.id) || !text(saved.projectId) || v.version !== saved.id))
        return undefined;
    if (!(text(v.fileKey) || (v.fileKey === '' && saved)) || ![v.nodeId, v.version, v.capturedAt].every(text)
        || !Number.isFinite(Date.parse(v.capturedAt)))
        return undefined;
    return { fileKey: v.fileKey, nodeId: v.nodeId, version: v.version, capturedAt: v.capturedAt,
        ...(saved ? { savedDesign: { id: saved.id, projectId: saved.projectId } } : {}) };
}
export function readComparisonContext(value) {
    if (!value || typeof value !== 'object')
        return undefined;
    const reference = value.reference;
    if (!reference || typeof reference.url !== 'string' || !Number.isFinite(reference.width)
        || !Number.isFinite(reference.height) || reference.width <= 0 || reference.height <= 0)
        return undefined;
    try {
        const url = new URL(reference.url);
        if (!['https:', 'http:'].includes(url.protocol))
            return undefined;
    }
    catch {
        return undefined;
    }
    const source = readComparisonReferenceSource(reference.source);
    return { reference: { ...(source ? { source } : {}), url: reference.url, width: reference.width, height: reference.height } };
}
/** The design behind a comparison, as a link a reader can open.
 *
 * A Figma frame opens in Figma at that node; a saved design copy names the
 * file it was saved from. Share 67919a1d (2026-10-23) carried 85 comparison
 * findings and named no file, node or version anywhere, so nobody could tell
 * which frame the "Design" values came from. One helper, so the share page and
 * every React issue surface print the same link and words. */
export function designSourceLink(source) {
    if (!source?.fileKey)
        return undefined;
    const href = `https://www.figma.com/design/${encodeURIComponent(source.fileKey)}?node-id=${encodeURIComponent(figmaNodeIdUrlParam(source.nodeId))}`;
    const detail = source.savedDesign ? `saved design ${source.version}` : `version ${source.version}`;
    return { href, label: 'Open design frame in Figma', detail };
}
//# sourceMappingURL=comparisonContext.js.map